import type { RouteRecordRaw } from 'vue-router'
import AppLayout from './layouts/AppLayout.vue'

export const routes: RouteRecordRaw[] = [
  // PC 端无独立页面，访问时重定向到首页
  { path: '/login', redirect: '/' },
  { path: '/contact-us', redirect: '/' },
  { path: '/setting', redirect: '/' },
  { path: '/content/:contentId/scroll/:chapterId', redirect: to => ({ name: 'chapter', params: to.params }) },
  { path: '/welfare', redirect: '/' },

  // PC 端暂无此类页面，重定向到首页
  { path: '/pay', redirect: '/' },
  { path: '/subscribe', redirect: '/' },
  { path: '/recommend/:contentId', redirect: '/' },
  { path: '/ranking/:columnId', redirect: '/' },

  // AppLayout 嵌套路由
  {
    path: '/',
    component: AppLayout,
    children: [
      { path: '', name: 'home', component: () => import('./pages/home/index.vue'), meta: { title: 'Novel', keepAlive: true } },
      { path: 'search', name: 'search', component: () => import('./pages/search/index.vue'), meta: { title: 'Search' } },
      { path: 'history', name: 'history', component: () => import('./pages/history/index.vue'), meta: { title: 'History', hideFooter: true } },
      { path: 'member', name: 'member', component: () => import('./pages/member/index.vue'), meta: { title: 'Profile' } },
      { path: 'recharge', name: 'recharge', component: () => import('./pages/recharge/index.vue'), meta: { title: 'Transaction History' } },
      { path: 'consume', name: 'consume', component: () => import('./pages/consume/index.vue'), meta: { title: 'Chapters UnLocked' } },
      { path: 'content/:contentId', name: 'book', component: () => import('./pages/book/index.vue'), meta: { title: 'Detail', hideFooter: true }, props: true },
      { path: 'content/:contentId/:chapterId', name: 'chapter', component: () => import('./pages/chapter/index.vue'), meta: { title: 'Chapter Detail', hideFooter: true }, props: true },
      { path: 'collection/:columnId', name: 'collection', component: () => import('./pages/collection/index.vue'), meta: { title: 'Collection' }, props: true },
      { path: 'tags', name: 'tags', component: () => import('./pages/tags/index.vue'), meta: { title: 'Tags' } },
      { path: '500', name: 'error', component: () => import('./pages/error/index.vue'), meta: { title: 'Error' } },
    ],
  },

  { path: '/paying', name: 'paying', component: () => import('./pages/paying/index.vue'), meta: { title: 'Payment' } },
  { path: '/:pathMatch(.*)*', name: 'notFound', component: () => import('./pages/404/index.vue'), meta: { title: '404' } },
]
